var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12109 8.30566L13.7695 10.9473L9.12109 13.5889V8.30566ZM21.875 2.34375V19.5312C21.875 20.8252 20.8252 21.875 19.5312 21.875H2.34375C1.0498 21.875 0 20.8252 0 19.5312V2.34375C0 1.0498 1.0498 0 2.34375 0H19.5312C20.8252 0 21.875 1.0498 21.875 2.34375ZM19.8242 10.9521C19.8242 10.9521 19.8242 8.04199 19.4531 6.64551C19.248 5.87402 18.6475 5.26855 17.8809 5.06348C16.499 4.6875 10.9375 4.6875 10.9375 4.6875C10.9375 4.6875 5.37598 4.6875 3.99414 5.06348C3.22754 5.26855 2.62695 5.87402 2.42188 6.64551C2.05078 8.03711 2.05078 10.9521 2.05078 10.9521C2.05078 10.9521 2.05078 13.8623 2.42188 15.2588C2.62695 16.0303 3.22754 16.6113 3.99414 16.8164C5.37598 17.1875 10.9375 17.1875 10.9375 17.1875C10.9375 17.1875 16.499 17.1875 17.8809 16.8115C18.6475 16.6064 19.248 16.0254 19.4531 15.2539C19.8242 13.8623 19.8242 10.9521 19.8242 10.9521Z",
    fill: "#FF0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.0cf7ce71b32cb80b4e704b09fe75c9c4.svg";
export { ForwardRef as ReactComponent };